const gtmSuccessRegistration = (cinestar_club) => {
    dataLayer.push({
        event: 'registration',
        step: 'registration_success',
        cinestar_club: cinestar_club ? 'ano' : 'ne',
        _clear: true,
    })
}

export default gtmSuccessRegistration
